export default __webpack_public_path__ + "static/media/bgMusicCardDark.b0b20e08.png";